import { planUtils } from 'utils/plan/plan.utils';

export const getIsSubInternal = (sub: Subscription, plan: Plan) => {
  const planType = planUtils.getType(plan);

  return planType === 'pro' && sub?.rcp?.cloud_account?.ownership === 'internal';
};
